import React from "react";
import siteContent from "../../generated/site-content";
import { skillIconMap } from "../../lib/site/iconRegistry";

function Skills() {
  return (
    <section className="w-full border-t theme-border pt-5 lg:pt-5">
      <div className="text-center lg:text-left">
        <h2 className="home-skills-title theme-text font-semibold tracking-tight">
          {siteContent.skills.title}
        </h2>
        <p className="home-skills-description theme-text-muted mx-auto mt-1.5 max-w-3xl lg:mx-0">
          {siteContent.skills.description}
        </p>
      </div>

      <div className="home-skills-card theme-surface mt-4 border theme-border">
        <div className="grid gap-x-6 gap-y-5 md:grid-cols-2 xl:grid-cols-4">
          {siteContent.skills.groups.map((group) => (
            <section key={group.title} className="space-y-3">
              <div className="text-center md:text-left">
                <h3 className="theme-text-muted text-[0.68rem] font-semibold uppercase tracking-[0.22em]">
                  {group.title}
                </h3>
                <div className="theme-divider-fill mx-auto mt-1.5 h-px w-8 md:mx-0" />
              </div>

              <ul className="flex flex-wrap justify-center gap-1.5 md:justify-start">
                {group.skills.map((skill) => {
                  const IconComponent = skillIconMap[skill.icon];

                  return (
                    <li
                      key={`${group.title}-${skill.name}`}
                      className="home-skill-chip theme-chip inline-flex items-center gap-1.5 rounded-full border font-medium"
                    >
                      <IconComponent className="theme-chip-icon text-[0.88rem]" />
                      <span>{skill.name}</span>
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
